<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_615_2549)">
                                    <path
                                        d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                                        fill="#265D91" />
                                    <path
                                        d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                                        fill="#265D91" />
                                    <path
                                        d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501"
                                        height="43.6498" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_615_2549" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>
                            Ajout intervenant
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="/intervenants">Intervenants</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Ajout intervenant</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container-content">
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section-title">
                                <h1 class="section-heading">Ajouter un intervenant</h1>
                            </div>
                        </div>

                        <div [formGroup]="intervenantForm">
                            <div class="card-body pt-0">
                                <div class="row">
                            <div class="col-lg-6 tools mt-4">
                              <!--begin::Label-->
                  
                              <label class="required fs-6 fw-semibold mb-2">
                                <span class="">Email personnel</span>
                              </label>
                              <!--end::Label-->
                              <!--begin::Input-->
                              <input type="email" formControlName="email" (change)="onSearch($event)"
                                class="form-control form-control-solid" placeholder="Email personnel" name="email" value="" />
                              <!--end::Input-->
                              <div *ngIf="intervenantForm.get('email')?.hasError('required') && intervenantForm.get('email')?.touched"
                                class="text-danger">
                                Le champ est obligatoire.
                              </div>
                              <div *ngIf="intervenantForm.get('email')?.hasError('pattern') && intervenantForm.get('email')?.touched"
                                class="text-danger">
                                La valeur de ce champ doit avoir une adresse email valide.
                              </div>
                            
                            </div>
                  
                  
                            <div class="col-lg-6 tools mt-4">
                  
                              <label class="fs-6 fw-semibold mb-2">
                                <span class=""> Email professionnel ESN</span>
                              </label>
                  
                              <!--end::Label-->
                              <!--begin::Input-->
                              <input type="email" formControlName="emailProESN"
                                class="form-control form-control-solid" placeholder="Email professionnel esn" name="emailProESN" value="" />
                              <!--end::Input-->
                              <div
                                *ngIf="intervenantForm.get('emailProESN')?.hasError('pattern') && intervenantForm.get('emailProESN')?.touched"
                                class="text-danger">
                                La valeur de ce champ doit avoir une adresse email valide.
                              </div>
                            </div>

                            <div class="col-lg-6 tools mt-4">
                              <label class="required fs-6 fw-semibold mb-2"> Prénom</label>
                              <input type="text" formControlName="first_name" class="form-control form-control-solid" placeholder="Prénom"
                                name="Prénom" />
                              <div
                                *ngIf="intervenantForm.get('first_name')?.hasError('required') && intervenantForm.get('first_name')?.touched"
                                class="text-danger">
                                Le champ est obligatoire.
                              </div>
                          
                              <div *ngIf="intervenantForm.get('first_name')?.hasError('pattern') && intervenantForm.get('first_name')?.touched"
                              class="text-danger">
                              La valeur de ce champ doit avoir un nom valide.
                              </div>
                  
                            </div>

                            <div class="col-lg-6 tools mt-4">
                              <label class="required fs-6 fw-semibold mb-2">Nom</label>
                              <input type="text" formControlName="last_name" class="form-control form-control-solid" placeholder="Nom"
                                name="Nom" />
                              <div
                                *ngIf="intervenantForm.get('last_name')?.hasError('required') && intervenantForm.get('last_name')?.touched"
                                class="text-danger">
                                Le champ est obligatoire.
                              </div>
                               <div *ngIf="intervenantForm.get('last_name')?.hasError('pattern') && intervenantForm.get('last_name')?.touched"
                                class="text-danger">
                                   La valeur de ce champ doit avoir un nom valide.
                                 </div>
                              </div>

                            <div class="col-lg-6 tools mt-4">
                              <label for="web">linkedin</label>
                                <input type="text" name="linkedin" id="linkedin" class="form-control form-control-solid mb-3" placeholder="https://www.linkedin.com/in/" formControlName="linkedin_link" (input)="setValidatorRequirements()" >
                            <!-- <div *ngIf="intervenantForm.get('linkedin_link')?.hasError('required') && intervenantForm.get('linkedin_link')?.touched" class="text-danger">
                          Le champ "linkedin" est obligatoire.
                            </div> -->
                          <div *ngIf="intervenantForm.get('linkedin_link')?.hasError('pattern') && intervenantForm.get('linkedin_link')?.touched" class="text-danger">
                                Entrer une URL valide exemple: https://www.linkedin.com/in/exemple
                          </div> 
                            </div>

                            <div class="col-lg-6 tools mt-4">
                              <div class="w-100">
                                  <div class="labels">
                                      <label for="cv" class="me-2" > Importer CV {{cvname}}</label> 
                                      <i class="fa fa-info-circle me-2" aria-hidden="true"  [style]="{color: '#265d91'}" [ngbTooltip]="'Le cv doit être (.pdf,.doc,.docx).'"></i>
                                      <button *ngIf="showResetButtons && fileName !== '' && !iscv" class="more-label"
                                      (click)="resetCV()">
                                      <img src="assets/media/icons/icon-delete.png" alt="" width="30px"
                                          class="cursor-pointer">
                                  </button>
                                  </div>
                              </div>
                              <input  *ngIf="!iscv" id="fileInput" #inputFile type="file" name="cv" id="cv" 
                              (change)="uploadFile($event);setValidatorRequirements()" class="form-control mb-3">
                  
                              <input *ngIf="iscv" type="text" name="cv" id="cv" formControlName="cv"
                              class="form-control mb-3" placeholder="cv" [readonly]="true" />
                  
                              <span style="color:red" *ngIf="fileError"><small>{{fileError}} </small></span>
                              <span style="color:red" *ngIf="fileExtention"><small>{{fileExtention}} </small></span>                  
                          </div>

                    <div class="col-lg-6 tools mt-4">
                        <!--begin::Label-->
                        <label class="required fs-6 fw-semibold mb-2">Rôle</label>
                        <!--end::Label-->
                        <!--begin::Input-->
                        <ng-select formControlName="employee_role_id" [items]="listRole" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                        [placeholder]="'Rôle'" autoComplete>
                        </ng-select>
                        <!-- <app-feild-error [control]="intervenantForm.get('employee_role_id')"></app-feild-error> -->
                        <!--end::Input-->
                        <div *ngIf="intervenantForm.get('employee_role_id')?.hasError('required') && intervenantForm.get('employee_role_id')?.touched"
                        class="text-danger">
                        Le champ est obligatoire.
                    </div>
                    </div>

                    <div class="col-lg-6 tools mt-4">
                        <label for="fin">Date de signature du contrat</label>
                        <div class="position-relative d-flex align-items-center calenderDate">
                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                        placeholder="Date" inputId="yearpicker"  formControlName="date_signature" id="date_signature" class="form-control mb-5"></p-calendar>
                        <div
                          *ngIf="intervenantForm.get('date_signature')?.hasError('required') && intervenantForm.get('date_signature')?.touched"
                          class="text-danger">
                          Le champ est obligatoire.
                        </div>
                        </div>
                    </div>

                    <div *ngIf="!isexistemail" class="col-lg-6 tools mt-4">
                      <label class="fs-6 fw-semibold mb-2">N° de téléphone </label>
                    
                      <form [formGroup]="phoneForm" class="phone-number">
                     <div class="wrapper">
                          <ngx-intl-tel-input [cssClass]="'form-control'"
                          [searchCountryPlaceholder]="'Rechercher un pays'"
                          [preferredCountries]="preferredCountries"
                          [enableAutoCountrySelect]="true"
                          [enablePlaceholder]="true"
                          [searchCountryFlag]="true"
                          [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                          [selectFirstCountry]="false"
                          [selectedCountryISO]="CountryISO.France"
                          [maxLength]="20" [phoneValidation]="true"
                          [separateDialCode]="separateDialCode"
                          [numberFormat]="PhoneNumberFormat.National"
                          name="phone" formControlName="phone" 
                          >
                      </ngx-intl-tel-input>
                   
                      <!-- <div *ngIf="phoneForm.get('phone')?.hasError('required') && phoneForm.get('phone')?.touched" class="text-danger">
                        Le champ est obligatoire.
                      </div> -->
                      <div *ngIf="!phoneForm.get('phone')?.hasError('required') && phoneForm.get('phone')?.invalid && phoneForm.get('phone')?.touched" class="text-danger">
                        Numéro de téléphone est invalide
                      </div>
                      <!-- <div *ngIf="phoneForm.controls['phone'].invalid && phoneForm.controls['phone'].touched">
                      <span class="text-danger">Numéro de téléphone est
                          invalide</span>
                        </div> -->
                  
                        </div>
                      </form>
                      
                  </div>

                  <div *ngIf="isexistemail && !phoneForm.get('phone')?.value"class="col-lg-6 tools mt-4">
                           
                    <label class="fw-semibold mb-2">N° de téléphone</label>
                    <div class="wrapper phone-number"  [formGroup]="phoneForm">
                      <ngx-intl-tel-input
                      [searchCountryPlaceholder]="'Rechercher un pays'"
                      [cssClass]="'form-control disabled-input'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="false" 
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.France"
                      [maxLength]="10"
                      [phoneValidation]="true"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National"
                      name="phone"
                      formControlName="phone"
                      (mousedown)="disableEvent($event)"
                      (keydown)="disableEvent($event)">
                    </ngx-intl-tel-input>
                    
                  </div>
                  
                  </div>

                  <div *ngIf="isexistemail && phoneForm.get('phone')?.value"class="col-lg-6 tools mt-4">
                           
                    <label class="fw-semibold mb-2">N° de téléphone</label>
                    <div class="wrapper phone-number"  [formGroup]="phoneForm">
                      <ngx-intl-tel-input
                      [searchCountryPlaceholder]="'Rechercher un pays'"
                      [cssClass]="'form-control disabled-input'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true" 
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.France"
                      [maxLength]="10"
                      [phoneValidation]="true"
                      [separateDialCode]="separateDialCode"
                      [numberFormat]="PhoneNumberFormat.National"
                      name="phone"
                      formControlName="phone"
                      (mousedown)="disableEvent($event)"
                      (keydown)="disableEvent($event)">
                    </ngx-intl-tel-input>
                    
                  </div>
                  
                  </div>
                  
                </div>
            </div>
                            <!--end::Modal body-->
                            <!--end::Modal content-->
            </div>

            </div>
                <div class="row card-body">
                    <div class="actions">
                         <a class="action-btn cancel" routerLink="/intervenants">Annuler</a>
                        <button  class="action-btn add"  (click)="addInterveanant()"
                        [disabled]="fileError||fileExtention ||
                        phoneForm.get('phone')?.invalid ||intervenantForm.get('employee_role_id')?.invalid||
                        intervenantForm.get('last_name')?.invalid || 
                        intervenantForm.get('first_name')?.invalid || 
                        intervenantForm.get('linkedin_link')?.invalid">
                            Confirmer
                        </button>
                    </div>
                </div>

                </div>
            </div>
        </div>
    </div>
</div>